import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
    const styleObj = {
        marginBottom: 2,
        verticalAlign: 'middle'
    };
    return (
        <div>
            <img className='home-image' src={require('../../images/home-image.png')} alt='Screenshot of a zoom call between 2 users with branded virtual backgrounds.'/>
            <p>
                Brand your zoom calls with your very own zoom virtual background.
            </p> 
            <p>
                You can create it easily. Graphic Design degree not required.
            </p>
            <p className="non-desktop-message">
                <strong>zoomback is a desktop tool. It's recommended to use zoomback on your computer.</strong>
            </p>
            <br/><br/>
            <Link to="/create">Create your zoomback <i style={styleObj} className="fas fa-arrow-right"></i></Link>
        </div>   
    )
}

export default Home;
